import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/modals-dux';
import ClubCancelForm from './ClubCancelForm';

const ClubCancellationModal = (
    { openModal,
        closeModal,
        cancelMembershipInProgress,
        clubDisableTypes,
        cancelMembership,
        clearCancelMembership,
        cancelMembershipError
    }
) => 
    {
    const onHideHandler = () => {
        if (cancelMembershipInProgress) return;
        closeModal('ClubCancellationModal');
        clearCancelMembership();
    }

    const cancellationOptions = (clubDisableTypes || []).map(({ TypeID, CustomerDescription}) => {
        return {
            label: CustomerDescription,
            value: TypeID     
           }
        })
    
    return (

    <Modal
        show={openModal === 'ClubCancellationModal'}
        onHide={onHideHandler}
        size='xl'
    >
        <Modal.Body>
            <ClubCancelForm 
              onCancel={onHideHandler}
              cancellationOptions={cancellationOptions}
              cancelMembershipInProgress={cancelMembershipInProgress}
              cancelMembershipError={cancelMembershipError}
              onSubmit={(values) => {
                const payload = { ...values};
                cancelMembership(payload, null, null, null);
            }}  
            />  
        </Modal.Body>
    </Modal>
    )
}

const mapState = state => {

    const {
        inProgress: cancelMembershipInProgress,
        error: cancelMembershipError
    } = state.cancelMembership.toJS();

    return {
        openModal: state.modals,
        cancelMembershipInProgress,
        cancelMembershipError
    }
}

const mapDispatch = dispatch =>
    bindActionCreators({
        cancelMembership: fetchDux.cancelMembership.createAction,
        clearCancelMembership: fetchDux.cancelMembership.clearAction,
        ...actionCreators
    }, dispatch)

export default connect(mapState, mapDispatch)(ClubCancellationModal);


